module.exports = __webpack_public_path__ + "img/ration-left.15bbe47b.svg";